import Modal from "..";
import { Button } from "@/components/ui/button";
import Image from "next/image";

const QuizResult = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Modal
      open={open}
      onOpenChange={() => setOpen(false)}
      classes={{ dialogContent: "sm:max-w-[586px]" }}
    >
      <div className="flex flex-col">
        <Image
          src={"/assets/course/quiz-submit.svg"}
          alt="quiz-submit"
          width={1000}
          height={700}
          className="mx-auto mb-6 h-auto w-full max-w-32 object-contain object-center"
        />
        <h3 className="text-primary textxl mb-4 text-center font-semibold lg:text-3xl">
          Quiz Submitted Successfully!
        </h3>

        <div className="mx-auto grid w-full max-w-80 grid-cols-2 gap-2">
          <p className="text-base text-slate-600 lg:text-xl">Point</p>
          <div className="text-base font-semibold text-slate-600 lg:text-xl">
            <span className="mx-4">:</span>2.5/11
          </div>
          <p className="text-base text-slate-600 lg:text-xl">Percentage</p>
          <div className="text-base font-semibold text-slate-600 lg:text-xl">
            <span className="mx-4">:</span>22.7%
          </div>
          <p className="text-base text-slate-600 lg:text-xl">Duration</p>
          <div className="text-base font-semibold text-slate-600 lg:text-xl">
            <span className="mx-4">:</span>00:22:55
          </div>
          <p className="text-base text-slate-600 lg:text-xl">Started Date</p>
          <div className="text-base font-semibold text-slate-600 lg:text-xl">
            <span className="mx-4">:</span>Thu 24 APR
          </div>
          <p className="text-base text-slate-600 lg:text-xl">End Date</p>
          <div className="text-base font-semibold text-slate-600 lg:text-xl">
            <span className="mx-4">:</span>Thu 24 APR
          </div>
        </div>

        <div className="mt-10 flex w-full justify-between gap-4">
          <Button
            type="button"
            variant="outline"
            className="w-1/2 rounded-full"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="w-1/2 rounded-full"
            variant="secondary"
            onClick={() => setOpen(false)}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default QuizResult;
